import { Inject, Injectable, Optional } from '@angular/core';

import { SESSION_SCOPED_STATE, SessionScopedState } from './session-scoped-state';

/**
 * Drops everything the app is remembering about the signed-in user.
 *
 * Called at both ends of the session rather than only on the way out. Not every
 * session ends by signing out — a rejected `/me` on start-up clears the stored
 * credentials on its own, and so does an expired token — so clearing on the way
 * in as well is what makes "a new session starts clean" true regardless of how
 * the last one finished.
 */
@Injectable({ providedIn: 'root' })
export class SessionStateResetService {
  constructor(
    @Optional()
    @Inject(SESSION_SCOPED_STATE)
    private readonly stores: readonly SessionScopedState[] | null,
  ) {}

  public clearAll(): void {
    for (const store of this.stores ?? []) {
      try {
        store.clearSessionState();
      } catch (error) {
        // One store failing must not strand the rest. This runs while a user is
        // being signed out, and half-cleared is the one outcome worse than a
        // logged complaint.
        console.error('[SessionStateReset] a store failed to clear', error);
      }
    }
  }
}
